//! @ngInject
export function trainingCenterLiveEventRecordingModalCtrl($scope, $uibModalInstance) {

    $scope.closeModal = function () {
        $uibModalInstance.close();
    };
};